import styles from './Support.module.scss'
import { Wrapper } from 'components/Wrapper/Wrapper'
import { WelcomeBlock } from 'components/WelcomeBlock/WelcomeBlock'
import { Deposit } from './components/Deposit/Deposit'
import { FAQ } from './components/FAQ/FAQ'
import { Dashboard } from 'components/Dashboard/Dashboard'
import { SUPPORT_ANALYTICS, SUPPORT_MOCK_DATA } from './consts'
import { useIsMobile } from 'hooks/useIsMobile'


export function Support() {
    const { isMobile } = useIsMobile()

    if (isMobile) {
        return (
            <>
                <div className={styles['mobile']}>
                    <div className={styles['mobile__content']}>
                        <div className={styles['welcome']}>
                            <WelcomeBlock text='Now you can make a deposit, and send a link to someone — he will claim an interest from your deposit.' />
                        </div>
                        <Deposit />
                        <FAQ />
                        <Dashboard data={SUPPORT_MOCK_DATA} analytics={SUPPORT_ANALYTICS} />
                    </div>
                </div>
            </>
        )
    }

    return (
        <Wrapper>
            <div className={styles['container']}>
                <div className={styles['info']}>
                    <div className={styles['welcome']}>
                        <WelcomeBlock text='Now you can make a deposit, and send a link to someone — he will claim an interest from your deposit.' />
                    </div>
                    <div className={styles['content']}>
                        <Deposit />
                        <FAQ />
                    </div>
                </div>
                <Dashboard data={SUPPORT_MOCK_DATA} analytics={SUPPORT_ANALYTICS} />
            </div>
        </Wrapper>
    );
}

